// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/icons/play-control.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-profile__post__video-control {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
.post-profile__post__video-control__background {
    background-color: black;
    opacity: 0.2;
    width: 100%;
    height: 100%;
}
.post-profile__post__video-control__icon {
    color: var(--secondary-color);
    position: absolute;
    /* background-color: rgba(77, 84, 81, 0.5); */
    font-size: calc(var(--space-x3)*1.3);
    text-align: center;
    width: calc(var(--space-x2)*2);
    height: calc(var(--space-x2)*2);
    padding-right: 2px;
    padding-top: 1px;
    padding-bottom: 2px;
    border-radius: 4px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: absolute;
    background-repeat: no-repeat;
    background-size: contain;
}
.post-profile__post__control-mute {
    position: absolute;
    bottom: 1%;
    right: 1%;
}
.post-profile__post__control-mute__icon {
    color: var(--secondary-color);
    font-size: var(--space-x2);
    background-color: rgba(77, 84, 81, 0.5);
    text-align: center;
    width: calc(var(--space-x2)*1.5);
    height: calc(var(--space-x2)*1.5);
    border-radius: 3px;
}

.post-profile__post > img {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.post-profile__container {
    flex: 0 0 33%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    padding: 0.5rem;
    box-sizing: border-box;
    max-width: 33%;
    aspect-ratio: 1 / 1;
}
  
.post-profile__container:before {
    content: '';
    display: table;
    padding-top: 100%;
}
  

.post-profile__post {
    height: 100%;
    flex-grow: 1;
    
    display: flex;
    justify-content: center;
    align-items: center;
    
    position: relative;
    aspect-ratio: 1 / 1 ;
}

.post-profile__video{
    object-fit: fill;
    width: 100%;
    height: 100%;
}

.post-profile-formation__content {
    clip-path: inset(0);
    aspect-ratio: 1 / 1;
}




.post-profile-formation__content .show-post-formation-field__container__img{
    width: -webkit-fill-available;
}

.post-profile-formation__content img.show-post-formation-field__field-img{
    width: inherit;
}

.post-profile-formation__content .show-post-field__container {
    display: flex;
    justify-content: center;
    position: relative;
}

.post-profile-formation__content .show-post-field__positions {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: -webkit-fill-available;
    height: -webkit-fill-available;
}

.post-profile-formation__content .show-post-formation-field{
    width: inherit;
    height: inherit;
    justify-content: space-between;
}

.post-profile__content{
    background: var(--white-color);
    width: 100%;
    padding: 10px;

    clip-path: inset(0);
    aspect-ratio: 1 / 1;
    border: 1px solid var(--new-gray-background-color);
}

.post-profile__content .baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.post-profile__content .show-post-poll__answer{
    width: inherit;
    display: inherit;
    white-space: nowrap; 
    overflow: hidden; 
    text-overflow: ellipsis; 
}

.post-profile__quoted__tag{
    padding: 4px 8px;
    border-radius: 22px;
    width: fit-content;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
}

.post-profile__quoted__tag.baloa-table{
    color: var(--white-color);
}

.post-profile__quoted__tag.green{
    background: var(--new-green-color);
}

.post-profile__quoted__tag.quiz{
    background: #5A82EA;
}

.post-profile__quoted__tag.poll{
    background: #F87A73;
}

.iconpq-quiz, .iconpq-poll{
    font-size: 16px;
    color: var(--white-color);
    margin-right: 5px;
}

.post-profile__quoted__tag .hubicon-article:before{
    font-size: 16px;
    color: var(--white-color);
    margin-right: 5px;
}

.post-profile__content .show-post-quiz__answer{
    margin-left: 0;
    margin-right: 0;
}

.post-profile__content .show-post-poll__answer{
    margin-left: 0;
    margin-right: 0;
}



@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
 
    .post-profile__container{
        padding: 0.2rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/posts/components/post-profile/PostProfileComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;AACA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,6CAA6C;IAC7C,oCAAoC;IACpC,kBAAkB;IAClB,8BAA8B;IAC9B,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yDAAkE;IAClE,kBAAkB;IAClB,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;AACA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,uCAAuC;IACvC,kBAAkB;IAClB,gCAAgC;IAChC,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;;AAGA;IACI,YAAY;IACZ,YAAY;;IAEZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;;;;AAKA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;;IAEb,mBAAmB;IACnB,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;;;AAIA,yCAAyC,4BAA4B;;IAEjE;QACI,eAAe;IACnB;AACJ","sourcesContent":[".post-profile__post__video-control {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.post-profile__post__video-control__background {\n    background-color: black;\n    opacity: 0.2;\n    width: 100%;\n    height: 100%;\n}\n.post-profile__post__video-control__icon {\n    color: var(--secondary-color);\n    position: absolute;\n    /* background-color: rgba(77, 84, 81, 0.5); */\n    font-size: calc(var(--space-x3)*1.3);\n    text-align: center;\n    width: calc(var(--space-x2)*2);\n    height: calc(var(--space-x2)*2);\n    padding-right: 2px;\n    padding-top: 1px;\n    padding-bottom: 2px;\n    border-radius: 4px;\n    background-image: url(\"../../../../assets/icons/play-control.png\");\n    position: absolute;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n.post-profile__post__control-mute {\n    position: absolute;\n    bottom: 1%;\n    right: 1%;\n}\n.post-profile__post__control-mute__icon {\n    color: var(--secondary-color);\n    font-size: var(--space-x2);\n    background-color: rgba(77, 84, 81, 0.5);\n    text-align: center;\n    width: calc(var(--space-x2)*1.5);\n    height: calc(var(--space-x2)*1.5);\n    border-radius: 3px;\n}\n\n.post-profile__post > img {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n}\n\n.post-profile__container {\n    flex: 0 0 33%;\n    display: flex;\n    justify-content: center;\n    align-items: stretch;\n    padding: 0.5rem;\n    box-sizing: border-box;\n    max-width: 33%;\n    aspect-ratio: 1 / 1;\n}\n  \n.post-profile__container:before {\n    content: '';\n    display: table;\n    padding-top: 100%;\n}\n  \n\n.post-profile__post {\n    height: 100%;\n    flex-grow: 1;\n    \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    \n    position: relative;\n    aspect-ratio: 1 / 1 ;\n}\n\n.post-profile__video{\n    object-fit: fill;\n    width: 100%;\n    height: 100%;\n}\n\n.post-profile-formation__content {\n    clip-path: inset(0);\n    aspect-ratio: 1 / 1;\n}\n\n\n\n\n.post-profile-formation__content .show-post-formation-field__container__img{\n    width: -webkit-fill-available;\n}\n\n.post-profile-formation__content img.show-post-formation-field__field-img{\n    width: inherit;\n}\n\n.post-profile-formation__content .show-post-field__container {\n    display: flex;\n    justify-content: center;\n    position: relative;\n}\n\n.post-profile-formation__content .show-post-field__positions {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 10;\n    width: -webkit-fill-available;\n    height: -webkit-fill-available;\n}\n\n.post-profile-formation__content .show-post-formation-field{\n    width: inherit;\n    height: inherit;\n    justify-content: space-between;\n}\n\n.post-profile__content{\n    background: var(--white-color);\n    width: 100%;\n    padding: 10px;\n\n    clip-path: inset(0);\n    aspect-ratio: 1 / 1;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.post-profile__content .baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.post-profile__content .show-post-poll__answer{\n    width: inherit;\n    display: inherit;\n    white-space: nowrap; \n    overflow: hidden; \n    text-overflow: ellipsis; \n}\n\n.post-profile__quoted__tag{\n    padding: 4px 8px;\n    border-radius: 22px;\n    width: fit-content;\n    margin-bottom: 8px;\n    display: flex;\n    align-items: center;\n}\n\n.post-profile__quoted__tag.baloa-table{\n    color: var(--white-color);\n}\n\n.post-profile__quoted__tag.green{\n    background: var(--new-green-color);\n}\n\n.post-profile__quoted__tag.quiz{\n    background: #5A82EA;\n}\n\n.post-profile__quoted__tag.poll{\n    background: #F87A73;\n}\n\n.iconpq-quiz, .iconpq-poll{\n    font-size: 16px;\n    color: var(--white-color);\n    margin-right: 5px;\n}\n\n.post-profile__quoted__tag .hubicon-article:before{\n    font-size: 16px;\n    color: var(--white-color);\n    margin-right: 5px;\n}\n\n.post-profile__content .show-post-quiz__answer{\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.post-profile__content .show-post-poll__answer{\n    margin-left: 0;\n    margin-right: 0;\n}\n\n\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n \n    .post-profile__container{\n        padding: 0.2rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
